
/**
 * This module provides a way to bypass or configure Lockdown.js restrictions
 * which are causing blank screens in production.
 */

// Check if lockdown global exists and configure it
export function configureLockdown() {
  // Wait for a brief moment to ensure lockdown is loaded
  setTimeout(() => {
    console.log("Configuring lockdown.js settings...");
    
    try {
      // Check if lockdown global exists
      if (typeof globalThis.lockdown === 'function') {
        console.log("Lockdown detected, attempting to configure it");
        
        // Try to configure lockdown with more permissive settings
        globalThis.lockdown({
          // Allow more intrinsics to pass through
          errorTaming: 'unsafe',
          overrideTaming: 'severe',
          consoleTaming: 'unsafe',
          mathTaming: 'unsafe',
          dateTaming: 'unsafe',
          domainTaming: 'unsafe',
          evalTaming: 'unsafeEval',
          stackFiltering: 'verbose',
          // Add other intrinsics that need to be accessible
          __allowedIntrinsics__: ['Promise', 'fetch', 'setTimeout', 'clearTimeout', 'React', 'ReactDOM']
        });
        
        console.log("Lockdown configured with more permissive settings");
      } else {
        console.log("Lockdown not detected in global scope");
      }
    } catch (err) {
      console.warn("Error while configuring lockdown:", err);
    }
  }, 0);
}

// Function to help bypass content security policy issues
export function bypassCSP() {
  try {
    // Check if we have a CSP issue by trying to access a few common APIs
    const hasRestrictions = (
      typeof eval !== 'function' || 
      document.querySelector('meta[http-equiv="Content-Security-Policy"]') !== null
    );
    
    if (hasRestrictions) {
      console.log("Detected potential CSP restrictions...");
      // Enable error reporting even with CSP
      window.addEventListener('error', (event) => {
        console.warn('CSP-related error:', event.message);
      });
    }
  } catch (err) {
    console.warn("Error in CSP check:", err);
  }
}

// Initialize both protections on import
export function initSafeguards() {
  configureLockdown();
  bypassCSP();
  console.log("Security safeguards initialized");
}

// Export a helper to fix common React-related issues with Lockdown
export function fixReactLockdownIssues() {
  try {
    // Ensure React and ReactDOM are available globally for components that may need them
    if (typeof window !== 'undefined') {
      if (window.React && globalThis.React !== window.React) {
        globalThis.React = window.React;
      }
      if (window.ReactDOM && globalThis.ReactDOM !== window.ReactDOM) {
        globalThis.ReactDOM = window.ReactDOM;
      }
    }
  } catch (err) {
    console.warn("Error fixing React lockdown issues:", err);
  }
}
